module.exports = __webpack_public_path__ + "static/media/  (24).e06f4ad6.jpg";